/*
 *
 * CommerceWebTenantPopup
 *
 */
import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.commerceWebTenantPopup.title'
      defaultMessage='Scegli il gruppo'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.commerceWebTenantPopup.description'
      defaultMessage='Seleziona il gruppo con cui vuoi accedere.'
    />
  ),
  selectLabel: (
    <PortalMessage
      id='t.app.commerceWebTenantPopup.selectLabel'
      defaultMessage='Gruppo'
    />
  ),
  placeholder: (
    <PortalMessage
      id='t.app.commerceWebTenantPopup.placeholder'
      defaultMessage='Seleziona gruppo'
    />
  ),
  ispOption: (
    <PortalMessage
      id='t.app.commerceWebTenantPopup.option.isp'
      defaultMessage='Intesa San Paolo'
    />
  ),
  nexiDirectOption: (
    <PortalMessage
      id='t.app.commerceWebTenantPopup.option.nexid'
      defaultMessage='Nexi Direct'
    />
  ),
  continue: (
    <PortalMessage
      id='t.app.continue'
      defaultMessage='Continua'
    />
  ),
  requiredError: (
    <PortalMessage
      id='t.app.error.requiredField'
      defaultMessage='Il campo è obbligatorio'
    />
  )
}

export default formattedMessage
